import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useTable, useSortBy, usePagination } from 'react-table'
import { Link } from 'react-router-dom';
import { CREATE } from '../../config/routes';
import DealListItem from './DealListItem/DealListItem';
import SortIconAsc from '../../assets/icons/SortIconAsc/SortIconAsc';
import SortIconDesc from '../../assets/icons/SortIconDesc/SortIconDesc';
import './DealList.scss';

const DealList = () => {
  const { t } = useTranslation();
  const store = useSelector(store => store);
  const storeName = store.app.storeName;
  const deals = store.list.deals;
  const data = React.useMemo(
    () => deals, 
    [ deals ]
  );
  const columns = React.useMemo(
    () => [
      {
        Header: t('table_head_status'),
        accessor: 'state',
        disableSortBy: true
      },
      {
        Header: t('table_head_name'),
        accessor: 'title'
      },
      {
        Header: t('table_head_date'),
        accessor: 'starts_at',
        sortType: 'alphanumeric'
      },
      {
        Header: t('table_head_activations'),
        accessor: 'activations',
        disableSortBy: true
      },
      {
        Header: '',
        accessor: 'edit',
        disableSortBy: true
      },
      {
        Header: '',
        accessor: 'delete',
        disableSortBy: true
      }
    ], [ t ]
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable(
    { 
      columns, 
      data 
    },
    useSortBy,
    usePagination
  );
  
  return (
    <div className="page-container">
      <div className="main-header"></div>
      <div className="page-header page-header--fixed">
        <div className="aurora-row">
          <div className="aurora-col--4">
            <h1 className="coral-Heading coral-Heading--1">
              { `${ t('list_title') } ${ storeName }` }
            </h1>
          </div>
          <div className="aurora-col--8 page-header__menu">
            <Link className="coral-Button coral-Button--primary" to={ CREATE }>
              { t('list_button') }
            </Link>
          </div>
        </div>
      </div>
      <div className="aurora-row coral-Form--fixed">
        <div className="aurora-col--12"></div>
      </div>
      <div className="page-table">
        <div className="aurora-row">
          <table { ...getTableProps() } className="coral-Table coral-Table--hover">
            <thead>
            { headerGroups.map(headerGroup => (
              <tr { ...headerGroup.getHeaderGroupProps() } className="coral-Table-row">
                { headerGroup.headers.map(column => (
                  <th
                  { ...column.getHeaderProps(column.getSortByToggleProps()) }
                  className="coral-Table-headerCell"
                  >
                    { column.render('Header') }
                    <span>
                      { column.isSorted
                          ? column.isSortedDesc
                            ? <SortIconDesc />
                            : <SortIconAsc />
                          : '' }
                    </span>
                  </th>
                )) }
              </tr>
            )) }
            </thead>
            <tbody {...getTableBodyProps()}>
              { rows.map((row) => {
                prepareRow(row)
                return (
                  <DealListItem
                    data={ row.original }
                    key={ row.original.deal_id }
                    { ...row.getRowProps() }
                  />
                )
              }) }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default DealList;